<div class="container">
    <mat-dialog-title class="title-block">
        <h2>DELETE IMPORT</h2>
        <app-close-x-icon [mat-dialog-close]="false"></app-close-x-icon>
    </mat-dialog-title>
    <mat-dialog-content class="content-block">
        Are you sure that you want to delete the import?
    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="yes-btn" mat-button [mat-dialog-close]="true">Yes</button>
        <button class="no-btn" mat-button [mat-dialog-close]="false">CANCEL</button>
    </mat-dialog-actions>
</div>